module.exports = __webpack_public_path__ + "img/work1-1.c00b876f.png";